import { getCsrfToken, getEnv } from '@ctct/ctct-helpers';

const ctoken = getCsrfToken();
const env = getEnv();

export const billingURL = `https://app${env}constantcontact.com/pages/myaccount/settings/billing`;

export const billinginfoURL = `https://app${env}constantcontact.com/pages/myaccount/base/billing/billinginfo?ctoken=${ctoken}`;

export const helpCenterURL = `https://community${env}constantcontact.com/help-center`;
